export enum PackState {
    Draft = 'Draft',
    Published = 'Published',
    Publishing = 'Publishing',
    PublicationFailed = 'PublicationFailed',
    TakenDown = 'TakenDown',
}

export enum SampleState {
    Available = 'Available',
    TakenDown = 'TakenDown',
}
